export const getRecaptchaLoginActionToken = async (): Promise<{
  recaptchaToken: string
  recaptchaAction: string
}> => {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      reject(new Error('grecaptcha timeout'))
    }, 15000)

    grecaptcha.enterprise.ready(async () => {
      try {
        const recaptchaAction = 'LOGIN'
        const recaptchaToken = await grecaptcha.enterprise.execute(
          process.env.GOOGLE_RECAPTCHA_KEY || '',
          { action: recaptchaAction },
        )
        resolve({ recaptchaToken, recaptchaAction })
      } catch (error) {
        reject(error)
      } finally {
        clearTimeout(timeout)
      }
    })
  })
}
